import React from 'react'
import type { Order } from '@ztechapps/common.contract'
import { useAiChatContext } from '../../ai-chat/Context'
import { EntityCreatedMessage } from '../EntityCreatedMessage'

export type OrderCreatedMessageProps = {
  order: Order
  fileAttached?: boolean
}

/**
 * Renders the "Order Created" structured result emitted by the `createOrder`
 * MCP tool (`kind: 'order-created'`). URL construction is delegated per-surface
 * via the optional `orderUrl` builder on `AiChatProvider` — the MCP tool never
 * embeds a hardcoded route. Visual shape lives in the shared
 * `EntityCreatedMessage` so this wrapper stays a single-purpose adapter.
 */
export const OrderCreatedMessage = ({ order, fileAttached }: OrderCreatedMessageProps) => {
  const { orderUrl } = useAiChatContext()
  const code = order?.code ?? ''
  return (
    <EntityCreatedMessage
      label="Order Created:"
      code={code}
      ariaLabel={`View order ${code}`}
      url={orderUrl?.(order)}
      fileAttached={fileAttached}
    />
  )
}
